module.exports = __webpack_public_path__ + "img/pablo-foncillas.8f730642.png";